/**
 * ShowConflictsCtrl controller
 */

/**
 * ShowConflictsCtrl controller
 *
 * @class ShowConflictsCtrl
 * @memberof mwApp/subscribers
 * @see mwApp/subscribers
 *
 * @ngdoc controller
 * @name mwApp/subscribers.controller:ShowConflictsCtrl
 */
/* @ngInject */
export default function ShowConflictsCtrl ($uibModalInstance, $http, ids, type, serverError) {
  var vm = this
  vm.serverError = serverError

  /**
   * Array of conflicts Id
   *
   * @memberof mwApp/subscribers.controller:ShowConflictsCtrl
   * @type {Array}
   */
  vm.ids = ids

  /**
   * Type
   *
   * @memberof mwApp/subscribers.controller:ShowConflictsCtrl
   * @type {String}
   */
  vm.type = type

  vm.submitId = function (id) {
    $uibModalInstance.close(id)
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/subscribers.controller:ShowConflictsCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
